"use client";

import { useEffect, useState } from "react";
import { getSectionsApi } from "../services/learning.api";
import type { LearningSectionItem } from "../types/learning";

export function useSections(
  locale: string,
  regionSlug?: string,
  onlyWithCourses?: boolean,
  onlyInNavbar?: boolean,
  onlyOnHomepage?: boolean
) {
  const [sections, setSections] = useState<LearningSectionItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    const loadSections = async () => {
      setLoading(true);

      try {
        const nextSections = await getSectionsApi(locale, regionSlug, onlyWithCourses, onlyInNavbar, onlyOnHomepage);

        if (!ignore) {
          setSections(nextSections);
        }
      } catch {
        if (!ignore) {
          setSections([]);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    void loadSections();

    return () => {
      ignore = true;
    };
  }, [locale, regionSlug, onlyWithCourses, onlyInNavbar, onlyOnHomepage]);

  return { sections, loading };
}
